<template>
  <div class="full-effect" :class="{ embedded }">
    <header class="page-header">
      <button v-if="!embedded" class="back" @click="$router.back()">
        <van-icon name="arrow-left"/>
      </button>
      <div class="page-title">全效</div>
    </header>

    <main class="content">
      <div class="group-label">核心决策</div>
      <section class="quick-grid" aria-label="常用管理入口">
        <button v-for="entry in filteredPrimary" :key="entry.name" class="quick-entry" @click="go(entry)">
          <span class="entry-icon"><van-icon :name="entry.icon"/></span>
          <span class="entry-copy"><b>{{ entry.label }}</b><small>{{ entry.description }}</small></span>
          <van-icon name="arrow" class="entry-arrow"/>
        </button>
      </section>

      <section v-if="showOtherSection" class="other-section">
        <div class="section-title"><span>其他</span><small>经营分析与效能诊断</small></div>
        <button v-for="entry in otherEntries" :key="entry.name" class="other-entry" @click="go(entry)">
          <span class="other-icon"><van-icon :name="entry.icon"/></span>
          <span><b>{{ entry.label }}</b><small>{{ entry.description }}</small></span>
          <van-icon name="arrow"/>
        </button>
      </section>
    </main>
  </div>
</template>

<script>
import coreapi from '@/utils/coreapi';

export default {
  name: 'BossFullEffect',
  props: {embedded: Boolean},
  data() {
    return {
      showOtherSection: false,
      primaryEntries: [
        {name: 'BossStrategyExecution', label: '战略落地', description: '定方向、建项目、看执行结果', icon: 'cluster-o'},
        {name: 'BossTasks', label: '下发任务', description: '重大/临时任务', icon: 'todo-list-o'},
        {name: 'BossPerformanceConfig', label: '绩效调整', description: '制定绩效标准', icon: 'edit'},
        {name: 'BossDutyAdjust', label: '岗位职责调整', description: '改到后台组合职责范围', icon: 'records'},
        {name: 'BossGovernanceCenter', label: '安全阀设置', description: '公司治理与 AI 安全阀', icon: 'warning-o'},
        {name: 'BossKnowledgeUpload', label: '上传材料', description: '上传公司资料', icon: 'upgrade'},
        {name: 'BossProjectValueRanking', label: '项目价值排序', description: '按价值、投效比和风险查看项目', icon: 'bar-chart-o'},
        {name: 'SupervisorHome', label: '主管工作台', description: '团队复核与诊断', icon: 'manager-o'}
      ],
      otherEntries: [
        {name: 'BossHeatmap', label: '全公司效能热力图', description: '部门与岗位绩效分布', icon: 'cluster-o'},
        {name: 'BossReport', label: '公司月度汇总', description: '月度绩效与风险一览', icon: 'description'},
        {name: 'BossLogRankings', label: '日志综合榜', description: '多维度日志排行', icon: 'bar-chart-o'},
        {name: 'BossRationality', label: '绩效合理性分析', description: '识别评分与职责偏差', icon: 'warning-o'}
      ]
    };
  },
  created() {
    this.refreshSession();
  },
  methods: {
    async refreshSession() {
      try {
        await coreapi.synchronize({
          employeeName: localStorage.getItem('CoreEmployeeName') || '当前用户',
          departmentKey: localStorage.getItem('CoreDepartmentKey') || localStorage.getItem('GovDepSysno') || 'UNASSIGNED',
          departmentName: localStorage.getItem('CoreDepartmentName') || '未归属部门',
          positionName: localStorage.getItem('CorePositionName') || '未配置岗位',
          positionFamily: localStorage.getItem('CorePositionFamily') || 'GENERAL_MANAGER',
          supervisor: localStorage.getItem('CoreSupervisor') === 'true'
        });
      } catch (e) { /* cached session is sufficient for navigation */
      }
    },
    go(entry) {
      this.$router.push({name: entry.name, query: {month: this.currentMonth}});
    }
  },
  computed: {
    currentMonth() {
      const d = new Date();
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
    },
    filteredPrimary() {
      // 带 roles 字段的入口做角色过滤
      let userRoles = [];
      try {
        userRoles = JSON.parse(localStorage.getItem('CoreIdentityRoles') || '[]').map(r => r.code);
      } catch (_) {}
      return this.primaryEntries.filter(e =>
        !e.roles || e.roles.some(role => userRoles.includes(role))
      );
    }
  }
};
</script>

<style scoped>
.full-effect {
  min-height: 100vh;
  background: #f6f7fb;
  padding-bottom: 24px;
  color: #303133
}

.full-effect.embedded {
  padding-bottom: 1.65rem
}

.page-header {
  position: relative;
  height: 46px;
  background: linear-gradient(90deg, #26191b, #c9272c);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px
}

.page-header .back {
  position: absolute;
  left: 8px;
  top: 50%;
  transform: translateY(-50%);
  border: 0;
  background: none;
  color: #fff;
  font-size: 22px;
  padding: 8px
}

.page-title {
  font-size: 16px;
  font-weight: 500;
  text-align: center
}

.content {
  max-width: 720px;
  margin: 0 auto;
  padding: 14px 12px 0
}

.guide-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
  padding: 12px 14px;
  border: 1px solid #f0e7e8;
  border-radius: 8px;
  background: #fff
}

.guide-bar > .van-icon {
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: #d9272e;
  background: #fff0f1;
  font-size: 19px
}

.guide-bar b, .guide-bar small {
  display: block
}

.guide-bar b {
  color: #30313a;
  font-size: 15px
}

.guide-bar small {
  margin-top: 3px;
  color: #9298a8;
  font-size: 12px
}

.group-label {
  margin: 0 2px 8px;
  color: #777d8f;
  font-size: 12px;
  font-weight: 500
}

.quick-grid {
  display: grid;
  grid-template-columns:repeat(2, minmax(0, 1fr));
  gap: 10px
}

.quick-entry {
  min-height: 104px;
  padding: 15px 12px;
  border: 1px solid #f0e7e8;
  border-radius: 8px;
  background: #fff;
  display: grid;
  grid-template-columns:40px minmax(0, 1fr) 15px;
  align-items: start;
  column-gap: 10px;
  text-align: left;
  box-shadow: 0 3px 12px rgba(38, 25, 27, .05)
}

.quick-entry:active {
  background: #fff5f5
}

.quick-entry:first-child {
  grid-column: 1/-1;
  min-height: 82px;
  align-items: center;
  background: #fff8f8;
  border-color: #f3d8d9
}

.quick-entry:nth-child(8) {
  grid-column: 1/-1;
  min-height: 82px;
  align-items: center
}

.entry-icon {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff0f1;
  color: #d9272e;
  font-size: 22px
}

.entry-copy {
  min-width: 0;
  padding-top: 2px
}

.entry-copy b {
  display: block;
  color: #30313a;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.35
}

.entry-copy small {
  display: block;
  margin-top: 7px;
  color: #9298a8;
  font-size: 12px;
  line-height: 1.45;
  word-break: break-word
}

.entry-arrow {
  position: static;
  align-self: center;
  justify-self: end;
  color: #b7bac2;
  font-size: 15px
}

.other-section {
  margin-top: 14px;
  background: #fff;
  border: 1px solid #f0e7e8;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 3px 12px rgba(38, 25, 27, .05)
}

.section-title {
  display: flex;
  align-items: center;
  padding: 14px 15px 11px;
  border-bottom: 1px solid #f0eef0
}

.section-title span {
  color: #30313a;
  font-size: 17px;
  font-weight: 600
}

.section-title small {
  margin-left: auto;
  color: #9298a8;
  font-size: 11px
}

.other-entry {
  width: 100%;
  min-height: 66px;
  padding: 11px 15px;
  border: 0;
  border-bottom: 1px solid #f0eef0;
  background: #fff;
  display: flex;
  align-items: center;
  gap: 11px;
  text-align: left
}

.other-entry:last-child {
  border-bottom: 0
}

.other-entry:active {
  background: #fff5f5
}

.other-entry > span:nth-child(2) {
  flex: 1;
  min-width: 0
}

.other-entry b {
  display: block;
  color: #30313a;
  font-size: 15px
}

.other-entry small {
  display: block;
  margin-top: 4px;
  color: #9298a8;
  font-size: 12px
}

.other-entry > .van-icon:last-child {
  color: #b7bac2
}

.other-icon {
  width: 34px;
  height: 34px;
  border-radius: 7px;
  background: #fff4f4;
  color: #d9272e;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 19px;
  flex: none
}

@media (min-width: 700px) {
  .quick-grid {
    grid-template-columns:repeat(3, minmax(0, 1fr))
  }

  .quick-entry:first-child, .quick-entry:nth-child(8) {
    grid-column: 1/-1
  }
}
</style>



// WEBPACK FOOTER //
// src/views/boss/FullEffect.vue